import {ReactNode} from 'react';

import {HelmetProvider} from 'react-helmet-async';

import AnnounceNewTitleOnPageChange from 'shared/PageHelmet/components/AnnounceNewTitleOnPageChange';

const HelmetProviderWithAccessibilityAnnouncer = ({children}: {children: ReactNode}) => (
  <HelmetProvider>
    <AnnounceNewTitleOnPageChange />
    {children}
  </HelmetProvider>
);

export default HelmetProviderWithAccessibilityAnnouncer;
